import { Chart as ChartJS, ArcElement, CategoryScale, LinearScale, Tooltip, Legend } from "chart.js";
import { useEffect, useState } from "react";

import { Pie } from "react-chartjs-2";
import { complexDigitToman, convertToJalaliWithoutTime } from "../../../../tools/tools";
ChartJS.register(ArcElement, CategoryScale, Tooltip, Legend);

const PieChart = ({ usageChart }) => {
  const [dataPie, setDataPie] = useState({});
  useEffect(() => {
    if (usageChart) {
      const chargeSales = Math.abs(usageChart?.chargeSales);
      const packageSales = Math.abs(usageChart?.packageSales);
      const spPurchaseSales = Math.abs(usageChart?.spPurchaseSales);

      const _chart = {
        labels: ["مجموع شارژ", "مجموع بسته", "مجموع سیم‌کارت"],
        datasets: [
          {
            data: [chargeSales, packageSales, spPurchaseSales],
            backgroundColor: ["#61AAFF", "#37B399", "#E64225"],
            borderColor: ["#61AAFF", "#37B399", "#E64225"],
            borderWidth: 1,
          },
        ],
      };
      setDataPie(_chart);
    }
  }, []);
  return (
    <>
      {dataPie?.labels && (
        <Pie
          data={dataPie}
          options={{
            responsive: true,
            plugins: {
              legend: {
                display: true,
                position: "top",
                labels: {
                  font: {
                    family: "IRANSansX",
                  },
                  padding: 20, // اعمال پدینگ به لیجند
                },
              },
              tooltip: {
                callbacks: {
                  label: function (context) {
                    let value = context.raw || 0;
                    return complexDigitToman(value) + " تومان";
                  },

                  afterLabel: function (context) {
                    const dataset = context.dataset;
                    const percent = (dataset.data[context.dataIndex] / dataset.data.reduce((a, b) => a + b)) * 100;
                    return percent.toFixed(2) + "%";
                  },
                },
                isplayColors: false,
                borderWidth: 1,
                bodySpacing: 10,
                titleMarginBottom: 10,
                titleFont: {
                  family: "IRANSansX",
                },
                bodyFont: {
                  family: "IRANSansX",
                },
                rtl: true,
              },
            },
            font: {
              family: "IRANSansX",
            },
          }}
        />
      )}
    </>
  );
};

export default PieChart;
